export default __webpack_public_path__ + "static/media/checklist-check-list-marker-bleu.a7db562c.jpg";